<template>
	<section class="section userbids">
		<Loading :active.sync="loading"></Loading>
		<div class="ht-profile-page">
			<div v-if="page == 0">
				<div class="columns is-centered">
					<div class="column is-10-widescreen is-9-fullhd">
						<Cmspos position="profile"></Cmspos>

						<div class="columns">
							<div class="column is-7">
								<b-button icon-left="sync-alt" @click="refreshTab">{{ $t('Refresh') }}</b-button>
							</div>
							<div class="column is-5">
								<b-field :label="$t('Selected auction')" label-for="selected_auction" position="is-right" horizontal>
									<b-select v-model="selectAuction" @change="changeAuction" :placeholder="$t('Select auction')" id="selected_auction" expanded>
										<option v-for="auction in auctionsList" :value="auction.id" :key="auction.id">{{
											auction.name
										}}</option>
									</b-select>
								</b-field>
							</div>
						</div>

						<b-tabs
							v-if="selectAuction"
							position="is-centered"
							type="is-boxed"
							v-model="selectedTab"
							@change="changeSelectedTabIndex"
							expanded
						>
							<b-tab-item :label="$t('user_page.products_won')"
							:to="{
								name: 'UserBidsPageTab',
								params: {page: '1', title: $t('user_page.products_won')}}">
								<WonBids
									v-bind:selectedTab="selectedTab"
									:callback="childrenEvent"
									v-bind:selectAuction="selectAuction"
									v-bind:refresh="refresh"
								></WonBids>
							</b-tab-item>
							<b-tab-item :label="$t('user_page.products_bidded')"
							:to="{
								name: 'UserBidsPageTab',
								params: {page: '1', title: $t('user_page.products_bidded')}}">
								<PlacedBids
									v-bind:selectedTab="selectedTab"
									v-bind:selectAuction="selectAuction"
									v-bind:refresh="refresh"
								></PlacedBids>
							</b-tab-item>
							<b-tab-item :label="$t('user_page.products_mine')"
							:to="{
								name: 'UserBidsPageTab',
								params: {page: '2', title: $t('user_page.products_mine')}}">
								<SellingBids
									v-bind:selectedTab="selectedTab"
									v-bind:selectAuction="selectAuction"
									v-bind:refresh="refresh"
								></SellingBids>
							</b-tab-item>
							<b-tab-item :label="$t('user_page.products_pay')"
							:to="{
								name: 'UserBidsPageTab',
								params: {page: '3', title: $t('user_page.products_pay')}}">
								<UserPays
									v-bind:selectedTab="selectedTab"
									v-bind:selectAuction="selectAuction"
									v-bind:refresh="refresh"
								></UserPays>
							</b-tab-item>
						</b-tabs>
					</div>
				</div>
			</div>

			<div v-if="page == 1">
				<div class="columns is-centered">
					<div class="column is-9-tablet is-7-widescreen is-6-fullhd">
						<h2 class="title">{{ $t('Checkout') }}</h2>
						<div class="columns">
							<div class="column">
								<label>{{ $t('Price') }}</label>
							</div>
							<div class="column is-narrow has-text-right">
								<strong>{{ pay_data.total | toCurrency($data._this, 'HUF') }}</strong>
							</div>
						</div>
						<div class="columns">
							<div class="column">
								<label for="post_methods">{{ $t('Shipping Method') }}</label>
							</div>
							<div class="column is-narrow has-text-right">
								<b-select
									v-model="pay_data.post_method"
									@change.native="updateTotalAll"
									:placeholder="$t('Select shipping method')"
									id="post_methods"
								>
									<option v-for="method in post_methods" :value="method" v-bind:key="method.type">{{
										$t(method.name)
									}}</option>
								</b-select>
							</div>
						</div>
						<!-- <div v-if="!showAddress" class="has-text-danger has-text-centered">{{ $t('Because of the ongoing pandemic we advise you to choose delivery instead of personal pickup when possible. Thank you.') }}</div> -->
						<div v-if="showAddress">
							<hr>
							<div class="columns">
								<div class="column">
									<small>{{ $t('You can change your shipping address here') }}</small>
								</div>
								<div class="column is-narrow has-text-right">
									<b-button
										v-if="this.$i18n.locale == 'hu'"
										tag="router-link"
										size="is-small"
										:to="{ name: 'AddressChange' }"
										target="_blank"
										>{{ $t('Change') }}</b-button
									>
									<b-button
										v-else
										tag="router-link"
										size="is-small"
										:to="{ name: 'AddressChange' }"
										target="_blank"
										>{{ $t('Change') }}</b-button
									>
								</div>
							</div>
							<div class="columns">
								<div class="column">
									<label>{{ $t('Contact name') }}</label>
								</div>
								<div class="column is-narrow has-text-right">{{ user.firstname }} {{ user.lastname }}</div>
							</div>
							<div class="columns">
								<div class="column">
									<label>{{ $t('Address') }}</label>
								</div>
								<div class="column is-narrow has-text-right">
									{{ user.country_code }} {{ user.postcode }} {{ user.region }} {{ user.city }} {{ user.address }}
								</div>
							</div>
							<div class="columns">
								<div class="column">
									<label>{{ $t('Invoice Address') }}</label>
								</div>
								<div class="column is-narrow has-text-right">
									{{ user.country_code }} {{ user.acc_postcode }} {{ user.acc_region }} {{ user.acc_city }} {{ user.acc_address }}
								</div>
							</div>
							<div class="columns">
								<div class="column">
									<label>{{ $t('Phone number') }}</label>
								</div>
								<div class="column is-narrow has-text-right">
									{{ user.phone }}
								</div>
							</div>
							<div class="columns">
								<div class="column">
									<label>{{ $t('Shipping cost') }}</label>
								</div>
								<div v-if="pay_data.post_method.type == 'delivery'" class="column is-narrow has-text-right">
									{{
										(pay_data.post_custom_price
											? pay_data.post_custom_price
											: pay_data.post_method.price[user.country_code == 'HU' ? 'hu' : 'other'])
											| toCurrency($data._this, 'HUF')
									}}
								</div>
								<div v-else class="column is-narrow has-text-right">
									{{
										pay_data.post_method.price[user.country_code == 'HU' ? 'hu' : 'other']
											| toCurrency($data._this, 'HUF')
									}}
								</div>
							</div>
							<hr>
						</div>
						<div class="columns">
							<div class="column">
								<label for="providers">{{ $t('Payment method') }}</label>
							</div>
							<div class="column is-narrow has-text-right">
								<b-select
									v-model="pay_data.pay_provider"
									@change.native="updateTotalAll"
									:placeholder="$t('Select pay method')"
									id="providers"
								>
									<option
										v-for="(provider, key) in providers"
										:value="provider"
										:key="key"
										:disabled="pay_data.post_method && pay_data.post_method.type == 'delivery' && provider.type == 'cash'"
										>{{ $t(provider.name) }}</option
									>
								</b-select>
							</div>
						</div>
						<div v-if="pay_data.pay_provider" class="columns">
							<div class="column">
								<label>{{ $t(this.pay_data.pay_provider.name) }} {{ $t('handling charge') }}</label>
							</div>
							<div class="column is-narrow has-text-right">
								{{
									Math.ceil(pay_data.total * (pay_data.pay_provider.commission - 1).toFixed(4))
										| toCurrency($data._this, 'HUF')
								}}
							</div>
						</div>
						<div class="columns" v-if="pay_data.pay_provider && pay_data.post_method">
							<div class="column">
								<label>{{ $t('Total amount') }}</label>
							</div>
							<div class="column has-text-right">
								<strong>{{ pay_data.total_all | toCurrency($data._this, 'HUF') }}</strong>
							</div>
						</div>
						<div class="field">
							<b-checkbox id="terms" @change.native="updateTotalAll" v-model="agreed" :required="true">
								{{ $t('I agree to the') }}
								<a :href="$i18n.locale == 'hu' ? '/site/aszf' : '/site/terms'" target="_blank">{{
									$t('terms and conditions')
								}}</a>
							</b-checkbox>
						</div>
						<hr>
						<div class="columns is-mobile">
							<div class="column">
								<b-button type="is-default" @click="page = 0">{{ $t('Back') }}</b-button>
							</div>
							<div class="column has-text-right">
								<b-button type="is-success" :disabled="!isPayButtonActive" @click="startPay()">{{
									$t('Start payment process')
								}}</b-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Cmspos from '@/components/common/Cmspos.vue'
import PlacedBids from '@/components/frontend/profiles/PlacedBids.vue'
import UserPays from '@/components/frontend/profiles/UserPays.vue'
import WonBids from '@/components/frontend/profiles/WonBids.vue'
import SellingBids from '@/components/frontend/profiles/SellingBids.vue'
// import ProductBid from '@/components/frontend/products/ProductBid.vue'

export default {
	name: 'UserBidsPage',
	components: {
		Loading,
		Cmspos,
		// ProductBid,
		PlacedBids,
		UserPays,
		WonBids,
		SellingBids,
	},
	metaInfo () {
		return {
			title: this.$route.params.title,
			meta: [
				{ name: 'robots', content: 'noindex' },
			]
		}
	},
	data() {
		return {
			page: 0,
			user: {},
			// eslint-disable-next-line vue/no-reserved-keys
			_this: this,
			loading: true,
			showAddress: false,
			isPayButtonActive: false,
			isUserModalActive: false,
			isBetModalActive: false,
			UserPreference: [],
			productList: [],
			auctionsList: [],
			auctionProduct: [],
			selectAuction: null,
			selectedTab: 0,
			providers: null,
			pay_data: {
				pay_provider: null,
				post_method: null,
				post_custom_price: null,
				total: 0,
				total_all: 0,
				user_data: null,
				bids: [],
			},
			post_methods: null,
			agreed: false,
			refresh: 0,
		}
	},
	methods: {
		refreshTab() {
			this.refresh++
		},
		changeAuction() {},
		changeSelectedTabIndex(val) {
			this.selectedTab = val
		},
		updateTotalAll() {
			this.pay_data.total_all = this.pay_data.total
			console.log('TOTAL ALL:', this.pay_data.total_all)
			if (this.pay_data.total_all == 0) {
				this.isPayButtonActive = false
				return false
			}
			if (this.pay_data.pay_provider) {
				this.pay_data.total_all += Math.ceil(
					this.pay_data.total * (this.pay_data.pay_provider.commission - 1).toFixed(4)
				)
			}
			if (this.pay_data.post_method !== null) {
				this.showAddress = true
				if (
					this.pay_data.post_method.type == 'delivery' &&
					this.pay_data.pay_provider &&
					this.pay_data.pay_provider.type === 'cash'
				) {
					this.pay_data.pay_provider = null
				} else if (this.pay_data.post_method.type == 'pickup') {
					this.showAddress = false
				}
				if (this.pay_data.post_method.type == 'delivery' && this.pay_data.post_custom_price > 0) {
					this.pay_data.total_all += this.pay_data.post_custom_price
				} else {
					this.pay_data.total_all += this.pay_data.post_method.price[this.user.country_code == 'HU' ? 'hu' : 'other']
				}
			}
			if (
				this.pay_data.post_method !== null &&
				this.pay_data.pay_provider !== null &&
				this.pay_data.total_all > 0 &&
				this.agreed
			) {
				this.isPayButtonActive = true
			} else {
				this.isPayButtonActive = false
			}
		},
		findMaxPostPrice() {
			console.log('_--_', this.productList)
			for (var i = 0; i < this.productList.length; i++) {
				console.log(this.productList[i])
			}
		},
		childrenEvent(total_all, product_post_price, wonbids) {
			this.pay_data.bids = wonbids.map((x) => x.id)
			this.page = 1
			this.pay_data.post_custom_price = product_post_price
			this.pay_data.total = total_all
			this.getProviders()
			this.getPostMethods()
		},
		getProviders: function () {
			var _this = this
			var path = '/order/providers'
			_this.$http.get(path).then((response) => {
				_this.providers = response.data.providers
			})
		},
		// eslint-disable-next-line no-unused-vars
		startPay: function (data) {
			var _this = this
			this.pay_data.user_data = {
				country_code: this.user.country_code,
				postcode: this.user.postcode,
				region: this.user.region,
				city: this.user.city,
				address: this.user.address,
				firstname: this.user.firstname,
				lastname: this.user.lastname,
			}
			_this.loading = true
			this.$http
				.post('/order/start-pay/' + this.pay_data.pay_provider.type, {
					auction_id: this.selectAuction,
					pay_data: this.pay_data,
					lang: localStorage.getItem('lang'),
				})
				.then((response) => {
					_this.loading = false
					const pay = response.data
					_this.$root.$emit('updateCart')

					if (pay.error) {
						alert('Hibakód:' + pay.error)
					} else if (pay.link) {
						_this.page = 0
						window.open(pay.link, 'transfer-pay', 'width=500,height=700')
						//window.open(pay.link, '_blank');
					}
				})
				.catch((err) => {
					alert('Hibakód:' + err)
					_this.loading = false
					console.log(err)
				})
		},
		getUser(cb) {
			var _this = this
			setTimeout(function () {
				_this.$http.get('/users').then((response) => {
					_this.user = response.data.user
					if (response.data.user.UserPreference) {
						_this.UserPreference = response.data.user.UserPreference
					} else {
						_this.UserPreference.currency = 'HUF'
					}
					if (typeof cb == 'function') {
						cb()
					} else {
						_this.loading = false
					}
				})
			})
		},
		getProducts(cb) {
			var _this = this
			this.$http
				.get('products')
				.then((response) => {
					_this.productList = response.data.products
					if (typeof cb == 'function') {
						cb()
					} else {
						_this.loading = false
					}
				})
				.catch((error) => {
					_this.loading = false
					console.log(error)
				})
		},
		getAuctionList(cb) {
			var _this = this
			this.$http.get('/auctions-last3').then((response) => {
				_this.auctionsList = response.data.auctions
				if (_this.auctionsList.length > 0) {
					_this.selectAuction = _this.auctionsList[0].id
				}
				if (typeof cb == 'function') {
					cb()
				} else {
					_this.loading = false
				}
			})

			this.loading = false
		},
		getPostMethods() {
			var _this = this
			_this.$http.get('/order/post-methods').then((response) => {
				_this.post_methods = response.data.post_methods
			})
			this.loading = false
		},
		getAuction: function (auction_id) {
			var _this = this
			var path = '/auction/' + auction_id
			let find = false
			for (var z in _this.auctionsList) {
				if (_this.auctionsList[z].id == auction_id) {
					find = true
				}
			}
			if (!find) {
				_this.$http.get(path).then((response) => {
					console.log('AUCTION:', response.data.auction)
					_this.auctionsList.push(response.data.auction)
					//_this.selectAuction = response.data.auction.id;
				})
			}
			_this.selectAuction = auction_id
		},
	},
	watch: {
		'$route.params': {
			handler(data) {
				this.selectedTab = parseInt(data.page)
			},
			immediate: true,
		},
		page: function () {
			this.getProviders()
			this.getPostMethods()
		},
	},
	mounted() {
		var _this = this
		console.log(this.pay_data)

		this.getAuctionList(() => {
			_this.getUser(() => {
				_this.getProducts(() => {
					if (typeof _this.$route.query.auction_id !== 'undefined') {
						//this.selectedAuction = this.$route.query.auction_id;
						_this.getAuction(this.$route.query.auction_id)
						console.log(this.pay_data)
					}
				})
			})
		})
		this.selectedTab = this.$route.params.page ? parseInt(this.$route.params.page) : 0
		this.$root.$on('changeTab', function (val) {
			_this.selectedTab = val
		})
	},
}
</script>

<style scoped>
.stat-val {
	font-size: 3em;
	padding-top: 20px;
	font-weight: bold;
}

.stat-key {
	font-size: 1.4em;
	font-weight: 200;
}

.section.profile-heading .column.is-2-tablet.has-text-centered + .has-text-centered {
	border-left: 1px dotted rgba(0, 0, 0, 0.2);
}

.control.is-pulled-left span.select {
	margin-right: 5px;
	border-radius: 2px;
}
.field >>> .field-label.is-normal {
	white-space: nowrap !important;
}

.b-tabs >>> .tab-content {
	padding: 0;
	padding-top: 1rem;
}

.control {
	text-align: right;
}
</style>
